<template>
    <div>
        <md-sidenav class="md-left" ref="leftSidenav" @open="open()" @close="close()">
            <md-toolbar class="md-large main-toolbar">
                <div class="md-toolbar-container ql-toolbar-logo">
                    <h1>
                        <img :src="require('../../../assets/img/cuelisttextWHITE.png')" alt="cuelisttext" class="logo-text" />
                        <img :src="require('../../../assets/img/cuelist.png')" alt="cuelist" class="logo" />
                    </h1>
                </div>
                <div class="md-toolbar-container ql-toolbar-avatar">
                    <md-avatar class="md-small">
                        <img :src="user.profile_picture" alt="People" v-if="user.profile_picture"/>
                        <img :src="require('../../../assets/img/silhouette.jpg')" v-else alt="People"/>
                    </md-avatar>
                    <div class="md-subtitle avatar-name-role" v-if="user.username">{{user.username}}</div>
                    <div class="md-subtitle avatar-name-role" v-else>Cuelist User</div>
                </div>
            </md-toolbar>
            <md-list>
                <router-link :to="{name: 'dashboard'}" tag="md-list-item">
                    <span @click="projectsClick()">All Projects</span>
                </router-link>
                <md-list-item v-if="project">
                    <span><strong>{{project.title}}</strong></span>
                </md-list-item>
                <md-list-item v-if="project">
                    <md-list>
                        <md-list-item @click="collaboratorsClick()">
                            <span>Collaborators</span>
                        </md-list-item>
                        <md-list-item @click="layersClick()">
                            <span>Layers</span>
                        </md-list-item>
                        <md-list-item @click="historyClick()">
                            <span>History</span>
                        </md-list-item>
                        <md-list-item @click="projectSettingsClick()">
                            <span>Project Settings</span>
                        </md-list-item>
                        <md-list-item @click="printClick()">
                            <span>Print</span>
                        </md-list-item>
                    </md-list>
                </md-list-item>
                <router-link tag="md-list-item" :to="{name: 'account'}">
                    <span>Account Settings</span>
                </router-link>
                <router-link tag="md-list-item" :to="{name: 'admin'}" v-if="user.admin">
                    <span>Admin Dashboard</span>
                </router-link>
                <li class="md-list-item">
                    <div class="md-button md-list-item-container">
                        <span>Help</span>
                    </div>
                    <md-button class="md-button-ghost" @click="helpClick"></md-button>
                </li>
                <md-list-item @click="logoutClick()">
                    <span>Log Out</span>
                </md-list-item>
            </md-list>
        </md-sidenav>
        <layers-nav :project="project" :user="user" v-if="project"/>
        <collaborators-nav :project="project" :user="user" v-if="project"/>
        <print-nav :project="project" :user="user" v-if="project"/>
        <project-settings-nav :project="project" :user="user" v-if="project"/>
        <history-nav :project="project" :user="user" v-if="project"/>
    </div>
</template>

<script>
import firebase from 'firebase';

import NavBus from '@/buses/nav';
import LayersNav from '@/components/layers/nav';
import CollaboratorsNav from '@/components/collaborators/nav';
import HistoryNav from '@/components/history/versions-nav';
import PrintNav from '@/components/print/nav';
import ProjectSettingsNav from '@/components/project-settings/nav';

/**
 * CoreNavMain
 */
const CoreNavMain = {
    name: 'CoreNavMain',
    props: ['project', 'user'],
    data: function() {
        return {
        };
    },
    methods: {
        open() {
            // console.log('Opened');
        },
        close() {
            // console.log('Closed');
        },
        closeMainNav() {
            this.$refs.leftSidenav.close();
        },
        projectsClick() {
            this.closeMainNav();
        },
        collaboratorsClick() {
            this.closeMainNav();
            NavBus.$emit('collaborators-nav.open');
        },
        layersClick() {
            this.closeMainNav();
            NavBus.$emit('layers-nav.open');
        },
        historyClick() {
            this.closeMainNav();
            NavBus.$emit('versions-nav.open');
        },
        projectSettingsClick() {
            this.closeMainNav();
            NavBus.$emit('project-settings-nav.open');
        },
        printClick() {
            this.closeMainNav();
            NavBus.$emit('print-nav.open');
        },
        logoutClick() {
            this.closeMainNav();
            firebase.auth().signOut().then(() => {
                this.$router.go('/login');
            });
        },
        helpClick() {
            window.open('https://www.thecuelist.com/additionalhelp/', '_blank');
        }
    },
    components: {
        'layers-nav': LayersNav,
        'collaborators-nav': CollaboratorsNav,
        'print-nav': PrintNav,
        'history-nav': HistoryNav,
        'project-settings-nav': ProjectSettingsNav
    },
    created: function() {
        NavBus.$on('main-nav.open', () => {
            if (this.$refs.leftSidenav) {
                this.$refs.leftSidenav.open();
            }
        });
    }
};
export default CoreNavMain;
</script>

<style lang="scss">
.md-sidenav {
    .md-list {
        width: 100%;
        .md-list-item {
            cursor: pointer;
            border-bottom: 1px solid #ddd;
            box-sizing: border-box;
        }
        .md-list {
            .md-list-item {
                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
    .md-toolbar-container {
        text-align: center;
        height: auto;
        h1, h2 {
            width: 100%;
        }
    }
    .ql-toolbar-logo {
        h1 {
            margin: 0;
        }
        .logo-text {
            width: 90%;
        }
        .logo {
            width: 40%;
        }
    }
    .md-toolbar-container.ql-toolbar-avatar {
        margin: 0.5em 0;
        display: flex;
        .md-avatar {
            margin-right: 0.5rem;
            flex: 0;
        }
        .avatar-name-role {
            flex: 1;
            text-align: left;
            font-size: 20px;
        }
    }
}

.md-avatar.md-xlarge {
    width: 128px;
    min-width: 128px;
    height: 128px;
    min-height: 128px;
    border-radius: 128px;
}
</style>


// WEBPACK FOOTER //
// main.vue?0cf6d702